import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Select} from "antd"
import queryString from "query-string"
import {listPartner} from "../../../../services/api/3dApi"

const {Option} = Select

class BatchesPartner extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errPartner: '',
            partners: {}
        }
    }

    componentDidMount() {
        this._fetchPartners()
    }

    _fetchPartners = async () => {
        try {
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const {data: response} = await listPartner(query)

            const {success, error, data} = response

            if (!success) {
                this.setState({
                    errPartner: error
                })

                return
            }

            this.setState({
                errPartner: '',
                partners: data.partners
            })
        } catch (e) {
            this.setState({})
        }
    }

    _handleChangePartner = (name, value) => {
        const {onChangePartner} = this.props

        if (typeof onChangePartner == 'function') {
            onChangePartner(name, value)
        }
    }

    render() {
        const {partners} = this.state

        return (
            <div className='col-12 col-xl-2 mb-3 filter-partner'>
                <label className="font-weight-bold d-block">Đối tác in ép</label>
                <Select
                    onChange={(value) => this._handleChangePartner('partner', value)}
                    defaultValue={[]} style={{ width: '100%' }}
                    placeholder='Đối tác in ép'
                    mode='multiple'
                    allowClear
                    showArrow
                    showSearch
                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    dropdownClassName='custom-select-partner'
                >
                    {/* <Option value=''>Tất cả</Option> */}
                    {
                        partners.length > 0 && partners.map(item => {
                            return <Option key={item._id} value={item._id}>{item.name}</Option>
                        })
                    }
                </Select>
            </div>
        )
    }
}

BatchesPartner.propTypes = {
    onChangePartner: PropTypes.func.isRequired
}

export default BatchesPartner
